module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACuSURBVDiNzdJNDgFBEAXgj0xwCj938BM3cAFXYWNnJSJOxTUk4gasWLBQMkOGGRvxkpdUvXS/6q4q/gVrnHAtyRNWUMEQW0yxK1mwg0XcNQ7XInRRz+RXjKslK8IGo1exyGARhFqw0KCJecSd4FvkGQwwK3jZR4OvkORo5yBcpBPK6k94HWMDvYhb7j2BvpwxJjiEMPG8SO1MPMgYkjZ2/ziwwlH5VT5imfed3+MGh/0w0eyzmywAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterprise/Reporting_16x16.png
// module id = vEkR
// module chunks = 0